import { Platform } from 'react-native';
import ExpoConstants from 'expo-constants';
import * as Crypto from 'expo-crypto';
import { getAnalytics, logEvent, setUserProperties } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import Constants from 'src/core/utils/Constants';
import type AnalyticsEventParams from 'src/core/models/AnalyticsEventParams';
import type AnalyticsUser from 'src/core/models/AnalyticsUser';
import type AnalyticsUserProperties from 'src/core/models/AnalyticsUserProperties';

const TAG = '[AnalyticsService] ->';

const firebaseConfig = ExpoConstants.expoConfig?.web?.config?.firebase;
const webAnalytics = firebaseConfig ? getAnalytics(initializeApp(firebaseConfig)) : null;

class AnalyticsService {
	setCollectionEnabled(enabled: boolean) {
		// Web has no equivalent toggle; collection follows the Firebase web config.
	}

	async sendEvent({
		name,
		params,
		user,
	}: {
		name: string;
		params: AnalyticsEventParams;
		user: AnalyticsUser | null;
	}): Promise<void> {
		if (!webAnalytics) {
			console.warn(TAG, 'No Firebase web config for this environment, skipping event', name);
			return;
		}

		params[Constants.analyticsParamPlatform] = Platform.OS;

		if (user) {
			params[Constants.analyticsParamUserId] = await Crypto.digestStringAsync(
				Crypto.CryptoDigestAlgorithm.SHA256,
				user.email,
			);
		}

		logEvent(webAnalytics, name, params);
	}

	// The web stream counts its views through page_view, a screen_view there would count every view twice.
	sendScreenView({ screenName, user }: { screenName: string; user: AnalyticsUser | null }): Promise<void> {
		return Promise.resolve();
	}

	setUserProperties(properties: AnalyticsUserProperties): Promise<void> {
		if (webAnalytics) {
			setUserProperties(webAnalytics, properties);
		}

		return Promise.resolve();
	}
}

export default new AnalyticsService();
